module.exports = "/images/contact-us-mail-icon.svg?bb631bf98287057bbea11f712ac38aa3";